// Bouton 📎 : ouvre le PDF d'origine d'une facture de vente ou d'achat (A1b,
// 02/11/2026). Sans PDF : « PDF absent » et les informations disponibles
// (tiers, date, HT, TVA, TTC). L'onglet est ouvert dès le clic (sinon bloqué
// comme pop-up), puis refermé si le PDF est absent.
import { useState } from "react";
import api from "../services/api";

const eur = (n) => (n == null ? "—" : `${Number(n).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`);
const frDate = (d) => (d ? String(d).slice(0, 10).split("-").reverse().join("/") : "—");

export default function InvoicePdfButton({ kind, id, style }) {
  const [absent, setAbsent] = useState(null); // infos affichées quand le PDF manque
  const [busy, setBusy] = useState(false);
  if (!id || !["vente", "achat"].includes(kind)) return null;
  const open = async (e) => {
    e.stopPropagation();
    if (absent) { setAbsent(null); return; }
    const tab = window.open("", "_blank");
    if (tab) tab.document.title = "Chargement…";
    setBusy(true);
    try {
      const blob = await api.invoices.pdfFile(kind, id);
      const url = URL.createObjectURL(blob);
      if (tab) tab.location.href = url;
      else Object.assign(document.createElement("a"), { href: url, download: "facture.pdf" }).click();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      if (tab) tab.close();
      try { setAbsent(await api.invoices.pdfInfo(kind, id)); } catch (err) { setAbsent({ error: err.message }); }
    } finally { setBusy(false); }
  };
  return (
    <span style={{ position: "relative", display: "inline-block", ...style }}>
      <button type="button" className="btn" onClick={open} disabled={busy} title="Ouvrir le PDF de la facture"
        style={{ fontSize: 11, padding: "1px 6px" }}>{busy ? "…" : "📎"}</button>
      {absent && (
        <span onClick={e => e.stopPropagation()} style={{ position: "absolute", zIndex: 40, top: "100%", left: 0, minWidth: 240, background: "#fff", border: "1px solid #e5e7eb",
          borderRadius: 6, boxShadow: "0 6px 18px #0002", padding: "6px 9px", fontSize: 11.5, color: "#374151", whiteSpace: "normal" }}>
          <strong style={{ color: "#b45309" }}>PDF absent</strong>
          {absent.error ? <div>{absent.error}</div> : (
            <div>
              {absent.number}{absent.supplier_ref ? ` (réf. fournisseur ${absent.supplier_ref})` : ""} · {absent.tiers || "—"} · {frDate(absent.date)}
              <div>HT {eur(absent.ht)} · TVA {eur(absent.tva)} · TTC {eur(absent.ttc)}</div>
            </div>
          )}
        </span>
      )}
    </span>
  );
}
